// extracted by mini-css-extract-plugin
export var carrierTab = "_4v-0";
export var carrierTabActive = "_4v-1 _4v-0";
export var carrierTabInactive = "_4v-2 _4v-0";
export var carrierTabLabel = "_4v-3";
export var carrierTabLabelActive = "_4v-4 _4v-3";
export var carrierTabLabelInactive = "_4v-5 _4v-3";
export var carrierTabPercentage = "_4v-6";
export var carrierTabPercentageActive = "_4v-7 _4v-6";
export var carrierTabPercentageInactive = "_4v-8 _4v-6";
export var carrierTabWinnable = "_4v-9";
export var carrierTabWinnableActive = "_4v-a _4v-9";
export var carrierTabWinnableInactive = "_4v-b _4v-9";
export var comparisonContainer = "_4v-d";
export var missingRateButton = "_4v-n";
export var missingRateButtonActive = "_4v-o _4v-n";
export var missingRateButtonInactive = "_4v-p _4v-n";
export var missingRateButtonLabel = "_4v-q";
export var missingRateButtonLabelActive = "_4v-r _4v-q";
export var missingRateButtonLabelInactive = "_4v-s _4v-q";
export var sidebar = "_4v-c";
export var strategyButton = "_4v-e";
export var strategyButtonActive = "_4v-f _4v-e";
export var strategyButtonDescription = "_4v-k";
export var strategyButtonDescriptionActive = "_4v-l _4v-k";
export var strategyButtonDescriptionInactive = "_4v-m _4v-k";
export var strategyButtonInactive = "_4v-g _4v-e";
export var strategyButtonLabel = "_4v-h";
export var strategyButtonLabelActive = "_4v-i _4v-h";
export var strategyButtonLabelInactive = "_4v-j _4v-h";
export var unitToggleButton = "_4v-t";
export var unitToggleButtonActive = "_4v-u _4v-t";
export var unitToggleButtonInactive = "_4v-v _4v-t";
export var unitToggleButtonLabel = "_4v-w";
export var unitToggleButtonLabelActive = "_4v-x _4v-w";
export var unitToggleButtonLabelInactive = "_4v-y _4v-w";